import { observer } from 'mobx-react';
import React from 'react';
import { Tracker } from '@udemy/event-tracking';
import { SubscriptionPlanProductType } from '@udemy/graphql';
import { useI18n } from '@udemy/i18n';
import { SubscriptionLearnMoreEvent } from '../../events';
import { useSubscribe } from '../../hooks/use-subscribe';
import { HeaderButton } from '../header-dropdown.react-component';

/**
 * Props for the `SubscribeButton` component.
 */

/**
 * ### SubscibeButton
 *
 * Should show up left of the Search bar, for taking users to learn more about the subscription product.
 */
export const SubscribeButton = observer(({
  className
}) => {
  const {
    gettext
  } = useI18n();
  const {
    subscribeUrl,
    showSubscribeButton
  } = useSubscribe();
  if (!showSubscribeButton) {
    return null;
  }
  const handleClick = () => {
    Tracker.publishEvent(new SubscriptionLearnMoreEvent('289661', SubscriptionPlanProductType.Consumersubscription, 'global_nav'));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-purpose": "subscribe-button"
  }, /*#__PURE__*/React.createElement(HeaderButton, {
    componentClass: "a",
    href: subscribeUrl,
    "data-testid": "subscribe-button",
    onClick: handleClick
  }, gettext('Subscribe')));
});
//# sourceMappingURL=subscribe-button.react-component.js.map